/* eslint-disable consistent-return */
/* eslint-disable object-curly-newline */
import React from 'react';
import * as momentTz from 'moment-timezone';
import * as R from 'ramda';
import { withStyles } from '@material-ui/styles';
import { withNamespaces } from 'react-i18next';
const footer = require('../../../../public/hb_powered_by_int.png');

const styles = (theme) => ({
  container: {
    backgroundColor: 'white',
    height: '21cm',
    width: '29.7cm',
    overflow: 'hidden',
  },
  metadataTitle: {
    width: '15%',
    fontSize: 10,
  },
  metadataValue: {
    width: '60%',
    fontSize: 10,
  },
  tdHeader: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    textAlign: 'left',
    fontSize: 8,
    fontWeight: 'bold',
    padding: 8,
  },
  td: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    textAlign: 'left',
    fontSize: 8,
    padding: 8,
    overflowWrap: 'anywhere',
  },
  tdTotal: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    fontSize: 12,
    padding: 8,
  },
  metadataSpace: {
    height: 10,
  },
});

@withNamespaces('pdf', { wait: true })
@withStyles(styles, { index: 1 })
class AdherenceReportComponent extends React.Component {
  KEY = 'adherenceReport';

  render = () => {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <div style={{ padding: 20 }}>
          {' '}
          {this._header()} <div style={{ height: 10 }}> </div>{' '}
          {this._table()} <div style={{ height: 10 }}> </div>{' '}
          {this._footer()}{' '}
        </div>{' '}
      </div>
    );
  };

  _header = () => {
    const { reportMetaData, classes, t } = this.props;
    if (!reportMetaData) return;
    const dateTimeReport = momentTz(new Date(reportMetaData.reportDate))
      .tz(reportMetaData.timezone)
      .format('DD MMM YYYY, hh:mm A');
    return (
      <div
        style={{
          width: '100%',
        }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={reportMetaData.hospitalLogo} style={{ width: 110, height: 110, marginTop: 12, marginBottom: 12 }} />{' '}
        </div>{' '}
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            marginTop: 12,
            marginBottom: 12,
          }}>
          {t(`${this.KEY}.title`, { monthYear: reportMetaData.monthYear })}{' '}
        </div>{' '}
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.hospitalClinicName`)}</td>{' '}
              <td className={classes.metadataValue}>: {reportMetaData.organizationName} </td>{' '}
            </tr>{' '}
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.periodOfReport`)}</td>{' '}
              <td className={classes.metadataValue}>: {reportMetaData.periodReportDate} </td>{' '}
            </tr>{' '}
            <tr>
              {' '}
              <td /> <td />{' '}
            </tr>{' '}
            <tr>
              {' '}
              <td /> <td />{' '}
            </tr>{' '}
            <tr>
              {' '}
              <td /> <td />{' '}
            </tr>{' '}
            <tr>
              {' '}
              <td /> <td />{' '}
            </tr>{' '}
            <tr>
              {' '}
              <td /> <td />{' '}
            </tr>{' '}
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.dateAndTimeOfReport`)}</td>{' '}
              <td className={classes.metadataValue}>: {dateTimeReport} </td>{' '}
            </tr>{' '}
            <tr>
              <td className={classes.metadataTitle}>{t(`${this.KEY}.meta.downloadedBy`)}</td>{' '}
              <td className={classes.metadataValue}>
                : {`${reportMetaData.name.firstName} ${reportMetaData.name.lastName}`}{' '}
              </td>{' '}
            </tr>{' '}
          </tbody>{' '}
        </table>
      </div>
    );
  };

  groupAdherence = (data) => {
    return data.map((cp) => {
      if (cp.cpType === 'QUESTIONNAIRE' && !R.isNil(cp.enrolledProgramId)) {
        const findEp = data.find((e) => e.cpId === cp.enrolledProgramId)
        if (!R.isNil(findEp) && R.isNil(findEp.questionnaires)) findEp['questionnaires'] = [cp];
        else if (!R.isNil(findEp) && Array.isArray(findEp.questionnaires)) findEp.questionnaires.push(cp)

        return null;
      }

      return cp
    }).filter((e, i, a) => {
      return !R.isNil(e)
    })
  }

  _table = () => {
    const { adherences, classes, t } = this.props;
    return (
      <div style={{ height: 355 }}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              <th className={classes.tdHeader} rowSpan={2} style={{ width: '0.5cm', textAlign: 'center' }}> {t(`${this.KEY}.table.sNo`)} </th>{' '}
              <th className={classes.tdHeader} colSpan={3} style={{ textAlign: 'center' }}> {t(`${this.KEY}.table.demographics`)} </th>{' '}
              <th className={classes.tdHeader} colSpan={5} style={{ textAlign: 'center' }}> {t(`${this.KEY}.table.vitals`)} </th>{' '}
              <th className={classes.tdHeader} colSpan={4} style={{ textAlign: 'center' }}> {t(`${this.KEY}.table.questionnaire`)} </th>{' '}
            </tr>{' '}
            <tr>
              <th className={classes.tdHeader}> {t(`${this.KEY}.table.participantName`)} </th>{' '}
              <th className={classes.tdHeader}> {t(`${this.KEY}.table.mobileNumber`)} </th>{' '}
              <th className={classes.tdHeader}> {t(`${this.KEY}.table.emailAddress`)} </th>{' '}

              <th className={classes.tdHeader}> {t(`${this.KEY}.table.programmeName`)} </th>
              <th className={classes.tdHeader}> {t(`${this.KEY}.table.vitalTypes`)} </th>{' '}
              <th className={classes.tdHeader} style={{width: '1cm'}}> {t(`${this.KEY}.table.adherenceRate`)}</th>{' '}
              <th className={classes.tdHeader} style={{width: '1cm'}}> {t(`${this.KEY}.table.noOfCompletedTasks`)}</th>{' '}
              <th className={classes.tdHeader} style={{width: '1cm'}}> {t(`${this.KEY}.table.noOfMissedTasks`)}</th>{' '}

              <th className={classes.tdHeader}> {t(`${this.KEY}.table.questionnaireName`)} </th>
              <th className={classes.tdHeader} style={{width: '1cm'}}> {t(`${this.KEY}.table.adherenceRate`)}</th>{' '}
              <th className={classes.tdHeader} style={{width: '1cm'}}> {t(`${this.KEY}.table.noOfCompletedTasks`)}</th>{' '}
              <th className={classes.tdHeader} style={{width: '1cm'}}> {t(`${this.KEY}.table.noOfMissedTasks`)}</th>{' '}
            </tr>{' '}
          </thead>{' '}
          <tbody> {adherences.map((n, i) => this._renderTableCellRow(n, i))} </tbody>{' '}
        </table>{' '}
      </div>
    );
  };

  _renderTableCellRow = (data) => {

    const { classes, t } = this.props;
    let vitalTitle, vitalMissed, vitalCompletionRate, vitals, vitalAdherence, questionnaireTitle, questionnaireMissed, questionnaireCompletionRate, questionnaireAdherence = '';
    if (data.cpType === "ENROLLED_PROGRAM") {
      vitalMissed = data.total - data.done;
      vitalCompletionRate = `${data.completionRate}%`;
      vitalAdherence = `${data.done}/${data.total}`;
      vitalTitle = data.cpTitle;
      vitals = data.vitals;
      if (data.total === 0) {
        vitalMissed = t(`${this.KEY}.common.na`);
        vitalCompletionRate = t(`${this.KEY}.common.na`);
        vitalAdherence = t(`${this.KEY}.common.na`);
      }

      if (!R.isNil(data.questionnaireEnrollment) && !R.isEmpty(data.questionnaireEnrollment)) {
        questionnaireMissed = data.questionnaireEnrollment.total - data.questionnaireEnrollment.done;
        questionnaireCompletionRate = `${data.questionnaireEnrollment.completionRate}%`;
        questionnaireAdherence = `${data.questionnaireEnrollment.done}/${data.questionnaireEnrollment.total}`;
        questionnaireTitle = data.questionnaireEnrollment.cpTitle;
        if (data.questionnaireEnrollment.total === 0) {
          questionnaireMissed = t(`${this.KEY}.common.na`);
          questionnaireCompletionRate = t(`${this.KEY}.common.na`);
          questionnaireAdherence = t(`${this.KEY}.common.na`);
        }
      } else {
        // questionnaireTitle = 'N.A';
        // questionnaireMissed = 'N.A';
        // questionnaireCompletionRate = 'N.A';
        // questionnaireAdherence = 'N.A'
      }
    }

    if (data.cpType === "QUESTIONNAIRE") {
      if (R.isNil(data.enrolledProgramId)) {
        // vitalTitle = "N.A";
        // vitalMissed = 'N.A';
        // vitalCompletionRate = 'N.A';
        // vitalAdherence = 'N.A';
        // vitals = "N.A";
      }
      questionnaireMissed = data.total - data.done;
      questionnaireCompletionRate = `${data.completionRate}%`;
      questionnaireAdherence = `${data.done}/${data.total}`;
      questionnaireTitle = data.cpTitle;
      if (data.total === 0) {
        questionnaireMissed = t(`${this.KEY}.common.na`);
        questionnaireCompletionRate = t(`${this.KEY}.common.na`);
        questionnaireAdherence = t(`${this.KEY}.common.na`);
      }
    }

    return (
      <tr key={data.id}>
        <td className={classes.td} style={{ width: 'auto' }}> {data.pageNo} </td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}>
          {data.pageNo && `${data.name.firstName} ${data.name.lastName}`}{' '}
        </td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {data.pageNo && `+${data.mobile.countryCode} ${data.mobile.value}`} </td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {data.pageNo && data.email} </td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {vitalTitle} </td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {vitals} </td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {vitalCompletionRate}</td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {vitalAdherence}</td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {vitalMissed} </td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {questionnaireTitle} </td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {questionnaireCompletionRate}</td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {questionnaireAdherence} </td>{' '}
        <td className={classes.td} style={{ width: 'auto' }}> {questionnaireMissed} </td>{' '}
      </tr>
    )
  }

  _footer = () => {
    const { page, totalPages, t } = this.props;
    return (
      <div >
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
          <div style={{ flex: 1 }}>
            <img src={footer} style={{ width: '50%', float: 'right', marginRight: '-30px' }} />
          </div>
          <div style={{ flex: 1 }}>
            <span style={{ float: 'right', fontSize: 12 }}>
              {t(`${this.KEY}.footer.pageOf`, { page, totalPages })}
            </span>
          </div>
        </div>
      </div>
    );
  };
}

export default AdherenceReportComponent;
